// src/components/App/index.tsx
import React from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';

import profile from '../../assets/profile.jpg';
import './style.css';

const App: React.FC = () => {
    return (
        <Container>
            <Row>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} xxl={3} className="profileCol">
                    <Image fluid roundedCircle src={profile} alt="profile" className="profile"/>
                </Col>
                <Col>
                    <h3>️Hello, world <span role="img" aria-label="victory hand">✌️</span></h3>
                    <p>I'm Evan Chen. I'm a software engineer <span role="img" aria-label="engineer">👨🏻‍💻</span>.</p>
                </Col>
            </Row>
        </Container>
    );
};

export default App;

